import { api } from "../../../orpc/client";
import { createTStore, type TStoreInit } from "../../lib/models/create-t-store";
import { TStore } from "../../lib/models/t-store";
import { nsModel } from "../../lib/namespace";
import { UserContactModel } from "./model.user";
import type { CoreError } from "../../lib/error";
import type { Self } from "../../lib/models/ref";

const userContactNS = nsModel("userContact");

@userContactNS.store
export class UserContactStore extends TStore<
  UserContactModel,
  Record<string, unknown>,
  typeof api.user.contact
> {
  Model = UserContactModel;
  api = api.user.contact;

  protected _sync(): Promise<void> {
    throw new Error("Method not implemented.");
  }
  syncById(_id: string): Promise<{}> {
    throw new Error("Method not implemented.");
  }
  updateById(_id: string, _data: Self<UserContactModel>): Promise<{}> {
    throw new Error("Method not implemented.");
  }

  get ready(): boolean | CoreError[] {
    return true;
  }
}

export const createUserContactStore = (
  incomingData?: TStoreInit<UserContactModel, UserContactStore>,
) =>
  createTStore<UserContactModel, UserContactStore>(
    UserContactStore,
    incomingData,
  );
